module.exports = __webpack_public_path__ + "img/actions-empty-image.fbdc3b31.webp";